// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
/**
 * Vocabulaire et petits composants partagés par l'écran de facturation et ses
 * onglets : statuts d'une facture, nature juridique du client, canal de
 * transmission, champ en lecture seule, ligne vide.
 */
import React from 'react';
import { Grid, Typography } from '@mui/material';

export const STATUS_DISPLAY = {
  draft: 'Brouillon',
  issued: 'Émise',
  deposited: 'Déposée',
  available: 'Mise à disposition',
  rejected: 'Rejetée',
  paid: 'Payée',
  cancelled: 'Annulée',
};

// Le thème habille les pastilles d'état (fond teinté à 14 %, texte à la couleur
// pleine), sauf `secondary`, dont MUI ferait un aplat ciel vif à texte noir.
// « Mise à disposition » reprend donc le bleu d'information d'« Émise », le
// libellé suffisant à les distinguer : les autres teintes de la charte (vert
// payé, rouge rejeté, ambre en retard) porteraient un sens étranger à l'état.
export const STATUS_COLOR = {
  draft: 'default',
  issued: 'info',
  deposited: 'primary',
  available: 'info',
  rejected: 'error',
  paid: 'success',
  cancelled: 'default',
};

export const ENTITY_KINDS = {
  public_etat: 'Public, État',
  public_local: 'Public, collectivité territoriale',
  public_sante: 'Public, établissement de santé',
  public_esms: 'Public, établissement social ou médico-social',
  prive_non_lucratif: 'Privé, non lucratif (association, fondation)',
  prive_commercial: 'Privé, commercial',
};

export const PUBLIC_ENTITY_KINDS = ['public_etat', 'public_local', 'public_sante', 'public_esms'];

// Le canal dit par quel chemin la facture est transmise. Stripe n'en est pas un :
// c'est un encaisseur, éteint pour le B2B (docs/billing/ENCAISSEMENT_B2B.md).
export const CHANNEL_LABEL = {
  manuel: 'Dépôt manuel',
  chorus_pro: 'Portail public de facturation',
  pdp: 'Plateforme de dématérialisation partenaire',
};

export function Champ({ label, children, xs = 6 }) {
  return (
    <Grid item xs={xs}>
      <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
      {/* `component="div"` : certaines valeurs sont un élément et non un texte
          (un manque signalé en rouge), et un paragraphe imbriqué dans un
          paragraphe est un balisage invalide que React signale à chaque rendu. */}
      <Typography component="div" variant="body2" sx={{ wordBreak: 'break-word' }}>{children}</Typography>
    </Grid>
  );
}

export function Empty({ texte: text }) {
  return (
    <Typography variant="body2" color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
      {text}
    </Typography>
  );
}
